export const LANGS = ["de", "sl", "hr"];

export const translations = {
  de: {
    nav: { services: "Leistungen", gallery: "Projekte", testimonials: "Kundenstimmen", about: "Über uns", contact: "Kontakt", quote: "Anfrage stellen" },
    hero: {
      kicker: "Fenster- & Sonnenschutzmontage",
      l1: "Sauber montiert.",
      l2: "Dicht. Für",
      l3: "Jahrzehnte.",
      sub: "Ihr regionaler Handwerksbetrieb für präzise Fenster- und Sonnenschutzmontage. Termintreu, sauber, mit echten Referenzen.",
      cta1: "Kostenlose Anfrage",
      cta2: "Projekte ansehen",
    },
    marquee: ["QUALITÄT", "ZUVERLÄSSIGKEIT", "HANDWERK", "VERTRAUEN", "TERMINTREUE"],
    stats: [
      { n: "15+", l: "Jahre Erfahrung" },
      { n: "800+", l: "Montagen" },
      { n: "100%", l: "Termintreue" },
      { n: "3", l: "Länder" },
    ],
    services: {
      title: "Was wir montieren",
      sub: "Zwei Kernbereiche, ein Anspruch: fachgerecht, dicht und langlebig.",
      fenster: { name: "Fenstermontage", desc: "Fachgerechter Einbau nach RAL-Richtlinie – wärmebrückenfrei, luftdicht und exakt ausgerichtet. Für Neubau und Sanierung." },
      sonnenschutz: { name: "Sonnenschutzmontage", desc: "Raffstore, Rollläden, Markisen und Screens – präzise montiert, wetterfest und langlebig für optimalen Schatten." },
      more: "Mehr erfahren",
    },
    about: {
      title: "Handwerk, auf das Verlass ist",
      chapters: [
        { t: "Beratung vor Ort", d: "Wir messen selbst auf und beraten ehrlich – kein Verkaufsdruck, nur die passende Lösung für Ihr Objekt." },
        { t: "Präzise Montage", d: "Fachgerechter Einbau nach anerkannten Regeln der Technik. Sauber, dicht und exakt – jedes Mal." },
        { t: "Saubere Übergabe", d: "Wir hinterlassen die Baustelle besenrein und nehmen die Montage gemeinsam mit Ihnen ab." },
      ],
    },
    gallery: { title: "Ausgewählte Projekte", sub: "Echte Aufträge. Vorher und nachher.", all: "Alle Projekte", detail: "Projekt ansehen", before: "Vorher", after: "Nachher", scope: "Umfang", location: "Ort", back: "Zurück zu Projekten", empty: "Bald folgen hier unsere Referenzen." },
    testimonials: { title: "Das sagen Kunden", sub: "Vertrauen entsteht durch Ergebnisse.", empty: "Kundenstimmen folgen in Kürze." },
    reviews: {
      formTitle: "Ihre Bewertung", formSub: "Waren Sie Kunde bei uns? Teilen Sie Ihre Erfahrung.",
      name: "Name", location: "Ort", rating: "Bewertung", text: "Ihre Bewertung",
      submit: "Bewertung absenden", sending: "Wird gesendet …",
      success: "Danke! Ihre Bewertung wird nach Prüfung veröffentlicht.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    },
    team: {
      kicker: "Team", title: "Ihre Ansprechpartner",
      sub: "Persönlich, erreichbar und mit Handschlagqualität – wir begleiten Ihr Projekt von Anfang bis Ende.",
      role: "Geschäftsführer",
      members: [
        { name: "Antonio Maticic", role: "Geschäftsführer", photo: "/team-antonio.jpg", phone: "+43 664 4551042", phone2: "+386 69 362 305", desc: "Gründer und Geschäftsführer. Verantwortlich für Beratung, Aufmaß und Planung – Ihr direkter Draht vom ersten Termin bis zur Übergabe." },
        { name: "Ante Jercic", role: "Co-Geschäftsführer", photo: "/team-ante.jpg", phone: "+43 676 7181244", desc: "Co-Geschäftsführer und Montage-Experte. Sorgt mit Blick fürs Detail für die präzise, saubere Umsetzung auf jeder Baustelle." },
      ],
    },
    contact: {
      title: "Anfrage stellen",
      sub: "Schreiben Sie uns – wir melden uns werktags innerhalb von 24 Stunden.",
      name: "Name", email: "E-Mail", phone: "Telefon", message: "Ihre Nachricht",
      send: "Anfrage senden", sending: "Wird gesendet …",
      success: "Danke! Ihre Anfrage ist eingegangen.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      whatsapp: "WhatsApp Chat", call: "Anrufen", hours: "Öffnungszeiten", findus: "So finden Sie uns",
      choose: "Ansprechpartner wählen",
      googleTitle: "Bewertungen auf Google", googleBtn: "Auf Google bewerten",
    },
    footer: { rights: "Alle Rechte vorbehalten.", imprint: "Impressum", privacy: "Datenschutz", nav: "Navigation", contact: "Kontakt" },
    seo: {
      home: { title: "AM-Montage | Fenster- & Sonnenschutzmontage – präzise & termintreu", desc: "Professionelle Montage von Fenstern, Raffstores, Rollläden & Pergolen in Österreich und Slowenien. Sauber, präzise, termintreu – jetzt kostenloses Angebot anfragen." },
      services: { title: "Leistungen – Fenster- & Sonnenschutzmontage | AM-Montage", desc: "Fenstermontage nach RAL-Richtlinie und Sonnenschutzmontage: Raffstores, Rollläden, Markisen & Pergolen. Fachgerecht eingebaut, wetterfest und langlebig." },
      projects: { title: "Referenzen & Projekte – Vorher/Nachher | AM-Montage", desc: "Echte Montage-Projekte mit Vorher-Nachher-Vergleich: Fenstertausch, Raffstore-Montage und Terrassenbeschattung. Überzeugen Sie sich von unserer Qualität." },
      about: { title: "Über uns – Ihr Montage-Team | AM-Montage", desc: "AM-Montage steht für Handwerksqualität mit Handschlag: erfahrenes Team, saubere Baustellen und präzise Ausführung bei jedem Fenster- und Sonnenschutzprojekt." },
      contact: { title: "Kontakt & kostenloses Angebot | AM-Montage", desc: "Jetzt unverbindlich anfragen: per Formular, WhatsApp oder Telefon. Wir beraten Sie persönlich zu Fenstern, Raffstores, Rollläden und Pergolen – Antwort innerhalb von 24 h." },
      imprint: { title: "Impressum | AM-Montage", desc: "Impressum und Firmendaten der AM MONTAGE, Antonio Matičić s.p., Ljubljana – Fenster- und Sonnenschutzmontage." },
      privacy: { title: "Datenschutz | AM-Montage", desc: "Datenschutzerklärung der AM-Montage: Informationen zur Verarbeitung Ihrer Daten bei Kontaktanfragen über unsere Website." },
    },
    legal: {
      imprint: "Impressum",
      privacy: "Datenschutz",
      placeholder: "Dies ist ein rechtssicherer Platzhalter. Die finalen Texte müssen über einen DSGVO-Generator (z. B. eRecht24) oder einen Anwalt eingeholt werden.",
      fields: { owner: "Inhaber", email: "E-Mail", phone: "Telefon", register: "Registrierungsnummer / Matična številka", tax: "Steuernummer / Davčna številka", iban: "IBAN / Firmenkonto", court: "Registereintrag" },
    },
    cats: { all: "Alle", fenster: "Fenster", sonnenschutz: "Sonnenschutz" },
  },
  sl: {
    nav: { services: "Storitve", gallery: "Projekti", testimonials: "Mnenja", about: "O nas", contact: "Kontakt", quote: "Povpraševanje" },
    hero: {
      kicker: "Montaža oken in senčil",
      l1: "Čisto vgrajeno.",
      l2: "Tesno. Za",
      l3: "desetletja.",
      sub: "Vaš regionalni obrtni mojster za natančno montažo oken in senčil. Točni, čisti, s pravimi referencami.",
      cta1: "Brezplačno povpraševanje",
      cta2: "Poglej projekte",
    },
    marquee: ["KAKOVOST", "ZANESLJIVOST", "OBRT", "ZAUPANJE", "TOČNOST"],
    stats: [
      { n: "15+", l: "let izkušenj" },
      { n: "800+", l: "montaž" },
      { n: "100%", l: "točnost" },
      { n: "3", l: "države" },
    ],
    services: {
      title: "Kaj montiramo",
      sub: "Dve glavni področji, en standard: strokovno, tesno in trajno.",
      fenster: { name: "Montaža oken", desc: "Strokovna vgradnja po RAL-smernicah – brez toplotnih mostov, zrakotesno in natančno poravnano. Za novogradnje in prenove." },
      sonnenschutz: { name: "Montaža senčil", desc: "Žaluzije, rolete, markize in screeni – natančno montirani, odporni na vremenske vplive in trajni." },
      more: "Več",
    },
    about: {
      title: "Obrt, na katero se lahko zanesete",
      chapters: [
        { t: "Svetovanje na kraju", d: "Sami izmerimo in pošteno svetujemo – brez prodajnega pritiska, le prava rešitev." },
        { t: "Natančna montaža", d: "Strokovna vgradnja po pravilih stroke. Čisto, tesno in natančno – vsakič." },
        { t: "Čista predaja", d: "Gradbišče zapustimo pometeno in montažo prevzamemo skupaj z vami." },
      ],
    },
    gallery: { title: "Izbrani projekti", sub: "Pravi projekti. Prej in potem.", all: "Vsi projekti", detail: "Poglej projekt", before: "Prej", after: "Potem", scope: "Obseg", location: "Kraj", back: "Nazaj na projekte", empty: "Kmalu tukaj naše reference." },
    testimonials: { title: "Kaj pravijo stranke", sub: "Zaupanje nastane z rezultati.", empty: "Mnenja sledijo kmalu." },
    reviews: {
      formTitle: "Vaša ocena", formSub: "Ste bili naša stranka? Delite svojo izkušnjo.",
      name: "Ime", location: "Kraj", rating: "Ocena", text: "Vaša ocena",
      submit: "Pošlji oceno", sending: "Pošiljanje …",
      success: "Hvala! Vaša ocena bo objavljena po pregledu.",
      error: "Nekaj je šlo narobe. Poskusite znova.",
    },
    team: {
      kicker: "Ekipa", title: "Vaši kontaktni osebi",
      sub: "Osebno in dosegljivo – vaš projekt spremljamo od začetka do konca.",
      role: "Direktor",
      members: [
        { name: "Antonio Maticic", role: "Direktor", photo: "/team-antonio.jpg", phone: "+43 664 4551042", phone2: "+386 69 362 305", desc: "Ustanovitelj in direktor. Odgovoren za svetovanje, izmere in načrtovanje – vaš neposredni stik od prvega termina do predaje." },
        { name: "Ante Jercic", role: "Sodirektor", photo: "/team-ante.jpg", phone: "+43 676 7181244", desc: "Sodirektor in strokovnjak za montažo. Z občutkom za detajle skrbi za natančno in čisto izvedbo na vsakem gradbišču." },
      ],
    },
    contact: {
      title: "Povpraševanje",
      sub: "Pišite nam – odgovorimo v 24 urah ob delavnikih.",
      name: "Ime", email: "E-pošta", phone: "Telefon", message: "Vaše sporočilo",
      send: "Pošlji", sending: "Pošiljanje …",
      success: "Hvala! Vaše povpraševanje smo prejeli.",
      error: "Nekaj je šlo narobe. Poskusite znova.",
      whatsapp: "WhatsApp klepet", call: "Pokliči", hours: "Delovni čas", findus: "Kje smo",
      choose: "Izberite kontaktno osebo",
      googleTitle: "Ocene na Googlu", googleBtn: "Ocenite nas na Googlu",
    },
    footer: { rights: "Vse pravice pridržane.", imprint: "Pravno obvestilo", privacy: "Zasebnost", nav: "Navigacija", contact: "Kontakt" },
    seo: {
      home: { title: "AM-Montage | Montaža oken in senčil – natančno in zanesljivo", desc: "Profesionalna montaža oken, žaluzij, rolet in pergol v Sloveniji in Avstriji. Čisto, natančno in točno – zahtevajte brezplačno ponudbo." },
      services: { title: "Storitve – montaža oken in senčil | AM-Montage", desc: "Montaža oken po RAL-smernicah ter montaža senčil: žaluzije, rolete, markize in pergole. Strokovna vgradnja, odporna na vremenske vplive in trajna." },
      projects: { title: "Reference in projekti – prej/potem | AM-Montage", desc: "Resnični montažni projekti s primerjavo prej–potem: menjava oken, montaža žaluzij in senčenje teras. Prepričajte se o naši kakovosti." },
      about: { title: "O nas – vaša montažna ekipa | AM-Montage", desc: "AM-Montage pomeni obrtniško kakovost: izkušena ekipa, urejena gradbišča in natančna izvedba pri vsakem projektu oken in senčil." },
      contact: { title: "Kontakt in brezplačna ponudba | AM-Montage", desc: "Povprašajte nezavezujoče: prek obrazca, WhatsAppa ali telefona. Osebno svetovanje o oknih, žaluzijah, roletah in pergolah – odgovor v 24 urah." },
      imprint: { title: "Pravno obvestilo | AM-Montage", desc: "Pravno obvestilo in podatki podjetja AM MONTAGE, Antonio Matičić s.p., Ljubljana – montaža oken in senčil." },
      privacy: { title: "Varstvo podatkov | AM-Montage", desc: "Izjava o varstvu podatkov AM-Montage: informacije o obdelavi vaših podatkov pri povpraševanjih prek naše spletne strani." },
    },
    legal: { imprint: "Pravno obvestilo", privacy: "Varstvo podatkov", placeholder: "To je pravno besedilo kot ograda. Končna besedila pridobite prek generatorja GDPR ali odvetnika.",
      fields: { owner: "Lastnik", email: "E-pošta", phone: "Telefon", register: "Matična številka", tax: "Davčna številka", iban: "IBAN / Poslovni račun", court: "Vpis v register" } },
    cats: { all: "Vse", fenster: "Okna", sonnenschutz: "Senčila" },
  },
  hr: {
    nav: { services: "Usluge", gallery: "Projekti", testimonials: "Recenzije", about: "O nama", contact: "Kontakt", quote: "Upit" },
    hero: {
      kicker: "Montaža prozora i zaštite od sunca",
      l1: "Čisto ugrađeno.",
      l2: "Nepropusno. Za",
      l3: "desetljeća.",
      sub: "Vaš regionalni obrtnik za preciznu montažu prozora i zaštite od sunca. Točni, uredni, s pravim referencama.",
      cta1: "Besplatan upit",
      cta2: "Pogledaj projekte",
    },
    marquee: ["KVALITETA", "POUZDANOST", "OBRT", "POVJERENJE", "TOČNOST"],
    stats: [
      { n: "15+", l: "godina iskustva" },
      { n: "800+", l: "montaža" },
      { n: "100%", l: "točnost" },
      { n: "3", l: "države" },
    ],
    services: {
      title: "Što montiramo",
      sub: "Dva glavna područja, jedan standard: stručno, nepropusno i trajno.",
      fenster: { name: "Montaža prozora", desc: "Stručna ugradnja prema RAL-smjernicama – bez toplinskih mostova, nepropusno i precizno poravnato. Za novogradnju i obnovu." },
      sonnenschutz: { name: "Montaža zaštite od sunca", desc: "Žaluzine, rolete, tende i screenovi – precizno montirani, otporni na vremenske uvjete i trajni." },
      more: "Saznaj više",
    },
    about: {
      title: "Obrt na koji se možete osloniti",
      chapters: [
        { t: "Savjet na licu mjesta", d: "Sami mjerimo i pošteno savjetujemo – bez pritiska prodaje, samo pravo rješenje." },
        { t: "Precizna montaža", d: "Stručna ugradnja prema pravilima struke. Uredno, nepropusno i precizno – svaki put." },
        { t: "Uredna primopredaja", d: "Gradilište ostavljamo pometeno i montažu preuzimamo zajedno s vama." },
      ],
    },
    gallery: { title: "Odabrani projekti", sub: "Pravi projekti. Prije i poslije.", all: "Svi projekti", detail: "Pogledaj projekt", before: "Prije", after: "Poslije", scope: "Opseg", location: "Lokacija", back: "Natrag na projekte", empty: "Uskoro naše reference." },
    testimonials: { title: "Što kažu klijenti", sub: "Povjerenje nastaje kroz rezultate.", empty: "Recenzije uskoro." },
    reviews: {
      formTitle: "Vaša recenzija", formSub: "Bili ste naš klijent? Podijelite svoje iskustvo.",
      name: "Ime", location: "Mjesto", rating: "Ocjena", text: "Vaša recenzija",
      submit: "Pošalji recenziju", sending: "Šalje se …",
      success: "Hvala! Vaša recenzija bit će objavljena nakon provjere.",
      error: "Nešto je pošlo po zlu. Pokušajte ponovno.",
    },
    team: {
      kicker: "Tim", title: "Vaše kontakt osobe",
      sub: "Osobno i dostupno – pratimo vaš projekt od početka do kraja.",
      role: "Direktor",
      members: [
        { name: "Antonio Maticic", role: "Direktor", photo: "/team-antonio.jpg", phone: "+43 664 4551042", phone2: "+386 69 362 305", desc: "Osnivač i direktor. Odgovoran za savjetovanje, izmjere i planiranje – vaš izravni kontakt od prvog termina do primopredaje." },
        { name: "Ante Jercic", role: "Sudirektor", photo: "/team-ante.jpg", phone: "+43 676 7181244", desc: "Sudirektor i stručnjak za montažu. S okom za detalje brine se za preciznu i urednu izvedbu na svakom gradilištu." },
      ],
    },
    contact: {
      title: "Pošaljite upit",
      sub: "Pišite nam – javljamo se u roku od 24 sata radnim danom.",
      name: "Ime", email: "E-mail", phone: "Telefon", message: "Vaša poruka",
      send: "Pošalji upit", sending: "Šaljem …",
      success: "Hvala! Vaš upit je zaprimljen.",
      error: "Nešto je pošlo po zlu. Pokušajte ponovno.",
      whatsapp: "WhatsApp chat", call: "Nazovi", hours: "Radno vrijeme", findus: "Gdje se nalazimo",
      choose: "Odaberite kontakt osobu",
      googleTitle: "Recenzije na Googleu", googleBtn: "Ocijenite nas na Googleu",
    },
    footer: { rights: "Sva prava pridržana.", imprint: "Impressum", privacy: "Privatnost", nav: "Navigacija", contact: "Kontakt" },
    seo: {
      home: { title: "AM-Montage | Montaža prozora i zaštite od sunca – precizno i pouzdano", desc: "Profesionalna montaža prozora, žaluzina, roleta i pergola u Austriji i Sloveniji. Uredno, precizno i na vrijeme – zatražite besplatnu ponudu." },
      services: { title: "Usluge – montaža prozora i zaštite od sunca | AM-Montage", desc: "Montaža prozora prema RAL-smjernicama te montaža zaštite od sunca: žaluzine, rolete, tende i pergole. Stručna ugradnja, otporna na vremenske uvjete i trajna." },
      projects: { title: "Reference i projekti – prije/poslije | AM-Montage", desc: "Stvarni montažni projekti s usporedbom prije–poslije: zamjena prozora, montaža žaluzina i sjenila za terase. Uvjerite se u našu kvalitetu." },
      about: { title: "O nama – vaš montažni tim | AM-Montage", desc: "AM-Montage znači obrtničku kvalitetu: iskusan tim, uredna gradilišta i precizna izvedba kod svakog projekta prozora i zaštite od sunca." },
      contact: { title: "Kontakt i besplatna ponuda | AM-Montage", desc: "Pošaljite neobvezujući upit: putem obrasca, WhatsAppa ili telefona. Osobno savjetovanje o prozorima, žaluzinama, roletama i pergolama – odgovor unutar 24 h." },
      imprint: { title: "Impressum | AM-Montage", desc: "Impressum i podaci tvrtke AM MONTAGE, Antonio Matičić s.p., Ljubljana – montaža prozora i zaštite od sunca." },
      privacy: { title: "Zaštita podataka | AM-Montage", desc: "Izjava o zaštiti podataka AM-Montage: informacije o obradi vaših podataka kod upita putem naše web stranice." },
    },
    legal: { imprint: "Impressum", privacy: "Zaštita podataka", placeholder: "Ovo je pravni tekst kao rezervirano mjesto. Konačne tekstove nabavite putem GDPR generatora ili odvjetnika.",
      fields: { owner: "Vlasnik", email: "E-mail", phone: "Telefon", register: "Matični broj", tax: "Porezni broj", iban: "IBAN / Poslovni račun", court: "Upis u registar" } },
    cats: { all: "Sve", fenster: "Prozori", sonnenschutz: "Zaštita od sunca" },
  },
};
